import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useOutletContext } from "react-router-dom";
import Loading from "../../components/Loading";
import SubscribeAccessCard from "../../components/SubscribeAccessCard";
import { requestNotificationPermission } from "../../firebase";
import Api from "../../service/http";
import { hasActiveAccess } from "../../utils/subscription";

const Alerts = () => {
  const { theme } = useSelector((state) => state.theme);
  const { user: contextUser } = useOutletContext() || {};
  const user = contextUser || JSON.parse(localStorage.getItem("user"));
  const subscribed = hasActiveAccess(user);
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchAlerts = async () => {
    if (loading || (lastPage && currentPage > lastPage)) return;
    setLoading(true);
    try {
      const response = await Api.get(`web/alerts?page=${currentPage}`);
      const data = response.data;
      console.log('Fetched alerts:', data);
      setAlerts([...alerts, ...data?.data]);
      setLastPage(data?.last_page || null);
    } catch (error) {
      console.error('Error fetching alerts:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAlerts()
  }, [currentPage])

  useEffect(() => {
    requestNotificationPermission();
  }, []);

  useEffect(() => {
    if (subscribed) return undefined;
    const scroller = document.querySelector("main .overflow-y-auto");
    if (!scroller) return undefined;
    const previous = scroller.style.overflow;
    scroller.style.overflow = "hidden";
    return () => {
      scroller.style.overflow = previous;
    };
  }, [subscribed]);

  return (
    <div className={`flex-1 flex flex-col h-full min-h-0 p-4 sm:p-6 ${subscribed ? "" : "overflow-hidden"} ${theme === 'dark' ? 'text-gray-200' : ''}`}>
      {loading && alerts.length === 0 ? (
        <div className="flex-1 flex items-center justify-center">
          <Loading message="Fetching Alerts..." />
        </div>
      ) : (
        <div className={`max-w-4xl mx-auto w-full ${subscribed ? "" : "flex-1 min-h-0 overflow-hidden"}`}>
          {alerts.length > 0 ? (
            <div className={`relative ${subscribed ? "" : "h-full overflow-hidden"}`}>
              <div
                className={
                  subscribed
                    ? ""
                    : "h-full overflow-hidden blur-[3px] pointer-events-none select-none"
                }
              >
                <div className="">
                  {alerts?.map((alert) => (
                    <div key={alert.id} className="mb-4 sm:mb-5">
                      <div className={`${
                        theme === 'dark' 
                          ? 'bg-blue-900/30 border-blue-700 text-blue-200' 
                          : 'bg-blue-50 border-blue-200 text-blue-700'
                      } border px-3 sm:px-4 py-2 sm:py-3 rounded-lg relative`} role="alert">
                        <p className="text-base sm:text-lg">
                          <pre className={`whitespace-pre-wrap break-words font-sans ${theme === 'dark' ? 'text-blue-200' : ''}`}>{alert?.message}</pre>
                        </p>
                      </div>
                      <p className={`text-[10px] sm:text-sm text-end mt-1 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
                        {moment(alert.created_at).fromNow()}
                      </p>
                    </div>
                  ))}
                </div>
                {subscribed && loading && (
                  <div className="flex justify-center items-center h-32">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
                  </div>
                )}
                {subscribed && (
                  <div className="flex justify-center">
                    <button
                      disabled={currentPage >= lastPage}
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                      className={`mt-4 px-4 py-2 bg-blue-500 text-white rounded-md ${(loading || (currentPage >= lastPage)) ? 'opacity-50 cursor-not-allowed' : ''}`}
                    >
                      {currentPage < lastPage ? 'Load More' : 'No More Alerts'}
                    </button>
                  </div>
                )}
              </div>

              {!subscribed && (
                <div className="absolute inset-0 z-10 flex items-center justify-center bg-slate-900/20 p-4 dark:bg-slate-950/30">
                  <SubscribeAccessCard
                    title="Unlock live alerts"
                    description="Subscribe to view real-time alerts and market updates from our team."
                    onSubscribeNow={() => navigate("/payment")}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className={`py-4 text-center ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
              No alerts found.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Alerts;
